import classNames from 'classnames';
import concat from 'lodash/concat';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'formik';
import { Input, Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import './Checkbox.css';

export class Checkbox extends Component {
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      inputValue: defaultValue || '',
    };
  }

  removeValue(name, value, field, setFieldValue) {
    const nextValue = filter(field.value, fieldValue => fieldValue !== value);
    setFieldValue(name, nextValue);
  }

  addValue(name, value, field, setFieldValue) {
    if (!field.value) return setFieldValue(name, [value]);
    const nextValue = concat(field.value, value);
    return setFieldValue(name, nextValue);
  }

  handleCheckboxChange = (name, value, field, setFieldValue) => {
    if (includes(field.value, value)) {
      this.removeValue(name, value, field, setFieldValue);
    } else {
      this.addValue(name, value, field, setFieldValue);
    }
  };

  handleInputChange = (value, field, setFieldValue) => {
    const nextValue = map(field.value, fieldValue => {
      if (fieldValue === this.state.inputValue) {
        return value;
      }
      return fieldValue;
    });
    setFieldValue(this.props.name, nextValue);
    this.setState({ inputValue: value });
  };

  render() {
    const {
      className,
      checkboxClassName,
      checkboxInputClassName,
      inputClassName,
      name,
      label,
      value,
      withInput,
    } = this.props;
    const { inputValue } = this.state;

    return (
      <Field name={name}>
        {({ field, form: { setFieldValue } }) => {
          const checked = includes(field.value, withInput ? inputValue : value);
          const showInput = withInput && checked;

          const onCheckboxChange = () =>
            this.handleCheckboxChange(
              name,
              withInput ? inputValue : value,
              field,
              setFieldValue,
            );

          const onInputChange = (event, { value: newInputValue }) =>
            this.handleInputChange(newInputValue, field, setFieldValue);

          return (
            <div className={className}>
              <SemanticCheckbox
                className={classNames(
                  checkboxClassName,
                  withInput && checkboxInputClassName,
                )}
                label={label || value}
                value={value}
                checked={checked}
                onChange={onCheckboxChange}
              />
              {showInput && (
                <Input
                  className={inputClassName}
                  onChange={onInputChange}
                  defaultValue={inputValue}
                />
              )}
            </div>
          );
        }}
      </Field>
    );
  }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  checkboxClassName: PropTypes.string,
  checkboxInputClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  withInput: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox/Checkbox.js